import React, { createContext, useState } from "react";

// Create context
export const PostContext = createContext(null);

// Provider
export function PostProvider({ children }) {
  const [postContent, setPostContent] = useState(null);

  return (
    <PostContext.Provider value={{ postContent, setPostContent }}>
      {children}
    </PostContext.Provider>
  );
}
